export default [
  {
    Companies: [
      {
        fileName: "login/companii/Homepage4.jpg",
        link:
          "#",
        category: "Banner",
        action: "Click",
        label: "companii_login_inchidere_mobilpay",
      },
      {
        fileName: "login/companii/Homepage3.jpg",
        link:
          "https://upmoldova.md/tichete-de-masa/",
        category: "Banner",
        action: "Click",
        label: "companii_login_profita_avantaje",
      },
      {
        fileName: "login/companii/Homepage1.jpg",
        link:
          "#",
        category: "Banner",
        action: "Click",
        label: "companii_login",
      },
      {
        fileName: "login/companii/Homepage2.jpg",
        link:
          "#",
        category: "Banner",
        action: "Click",
        label: "companii_login2",
      },
    ],
    Beneficiaries: [
      {
        fileName: "login/companii/Homepage4.jpg",
        link:
          "#",
        category: "Banner",
        action: "Click",
        label: "utilizatori_login_inchidere_mobilpay",
      },
      {
        fileName: "login/utilizatori/Homepage.jpg",
        link:
          "#",
        category: "Banner",
        action: "Click",
        label: "beneficiari_login",
      },
    ],
  },
];
